import { render, staticRenderFns } from "./Streaks.vue?vue&type=template&id=565e6bb4&scoped=true"
import script from "./Streaks.vue?vue&type=script&lang=js"
export * from "./Streaks.vue?vue&type=script&lang=js"
import style0 from "./Streaks.vue?vue&type=style&index=0&id=565e6bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e6bb4",
  null
  
)

export default component.exports